import React from 'react';

import InputText, {IInputTextProps} from './InputText';
import {createSingleUrlValidator} from '../../lib/validation/validateUrl';

const InputUrl: React.FC<IInputTextProps> = (props) => {
    const rules = createSingleUrlValidator();

    return (
        <InputText
            rules={rules}
            {...props}
        />
    );
};

export default InputUrl;